import { render, staticRenderFns } from "./logincode.vue?vue&type=template&id=f30247b8&scoped=true&"
import script from "./logincode.vue?vue&type=script&lang=js&"
export * from "./logincode.vue?vue&type=script&lang=js&"
import style0 from "./logincode.vue?vue&type=style&index=0&id=f30247b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30247b8",
  null
  
)

export default component.exports